import { CustomTabbedShowLayout } from './CustomTabbedShowLayout'
import { languages } from '../config/constants'

/**
 * LangRelatedTabbedShow - A specialized show layout component that automatically creates tabs for each language
 * 
 * @param {Array} generalFields - Array of React elements to render in the general section (above tabs)
 * @param {Function} tabFields - Function that receives a language object { id, label } and returns an array of React elements for that language's tab
 */
export const LangRelatedTabbedShow = ({ generalFields = [], tabFields }) => {
  if (!tabFields || typeof tabFields !== 'function') {
    throw new Error('LangRelatedTabbedShow requires tabFields as a function that receives a language object')
  }

  const tabs = languages.map(lang => ({
    label: lang.label,
    fields: tabFields(lang),
  }))

  return (
    <CustomTabbedShowLayout
      generalFields={generalFields}
      tabs={tabs}
    />
  )
}

